/** @format */

import * as actionTypes from "./../types";
import { apiError } from "../../utils/GTMDataLayer";
// import { logger } from "cbt-sdk";
import { logger } from "@goldenbird1/ui-logger-library";
import { v4 as uuidv4 } from "uuid";

export const getCartProductQuantity =
  (token, callback = "") =>
  async (dispatch) => {
        let url = `${process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL}/orders/v1/my/cart`;
    return await fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        Accept: "*/*",
        "trace-id": uuidv4(),
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          apiError(
            "getCartProductQuantity",
            res.statusText || "Error from getCartProductQuantity api.",
            "GET",
            "checkout"
          );
          throw res;
        }
      })
      .then((res) => {
        let result = { ...res };
        result["currency"] = "USD";
        console.log("testing:: response result -- ", result);
        if (callback) {
          callback(result);
        }
        return dispatch(setCartProductsQuantity(result));
      })
      .catch((err) => {
        logger(
          "error",
          "Error from getCartProductQuantity api: " +
            url +
            " :buyerId " +
            ": error => " +
            err.statusText,
          process.env.NEXT_PUBLIC_LOGGER_URL
        );
        apiError("getCartProductQuantity", err.statusText, "GET", "checkout");
        console.log(err);
        if (err.status === 401) {
          Router.push("/signin");
        }
        if (callback) {
          callback(err);
        }
      });
  };

export const setCartProductsQuantity = (data) => {
    let totalQuantity=0;
    data?.subOrders?.forEach(dataItem => {
        totalQuantity += dataItem?.products?.length || 0;
    });
  return {
    type: actionTypes.SET_CART_PRODUCTS_QUANTITY,
    payload: {
      cartProductsQuantity: totalQuantity,
    },
  };
};